<template lang="html">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path :fill="color" fill-rule="evenodd" clip-rule="evenodd" d="M12,1.999c-5.521,0-10,4.48-10,10C2,17.52,6.479,22,12,22
        c5.52,0,10-4.48,10-10.001C22,6.479,17.52,1.999,12,1.999z M15.938,15.779c-0.297,0.392-0.758,0.74-1.385,1.045
        c-0.627,0.306-1.418,0.459-2.375,0.459c-1.217,0-2.211-0.379-2.98-1.135c-0.77-0.757-1.155-1.739-1.155-2.947v-2.078
        c0-1.203,0.37-2.184,1.11-2.943c0.741-0.759,1.695-1.138,2.861-1.138c1.213,0,2.141,0.295,2.785,0.885s0.975,1.366,0.988,2.328
        l-0.014,0.041h-1.881c-0.035-0.529-0.205-0.947-0.506-1.254c-0.3-0.308-0.74-0.461-1.318-0.461c-0.611,0-1.104,0.236-1.477,0.707
        s-0.561,1.078-0.561,1.82v2.09c0,0.756,0.193,1.369,0.581,1.841s0.909,0.706,1.565,0.706c0.465,0,0.838-0.047,1.121-0.143
        c0.281-0.096,0.496-0.213,0.643-0.354v-1.84h-1.764v-1.381h3.76V15.779z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/GwQuality.vue